<div *ngIf="showProgress" class="progress-bar-wrap">
    <!--<div class="progress-bg"></div>
    <div class="progress-bar" [style.width]="progressWidth"></div>
    <div class="progress-width">{{progressWidth}}</div>-->

    <svg width="100%" preserveAspectRatio="none">
        <svg:defs>
            <svg:clipPath id="myClip">
                <svg:rect [attr.width]="progressWidth" height="60px"></svg:rect>
            </svg:clipPath>
        </svg:defs>
        <svg:g>
            <svg:rect fill="#666666" x="0" y="0" width="100%" height="10"></svg:rect>
            <svg:circle r="50" cx="50%" cy="0%" transform="translate(50%)" fill="#666666">
            </svg:circle>
            <svg:text x="50%" text-anchor="middle" y="25" fill="white">{{progressWidth}}</svg:text>
        </svg:g>
        <svg:g clip-path="url(#myClip)">
            <svg:rect fill="#5e8f1e" x="0" y="0" width="100%" height="10"></svg:rect>
            <svg:circle r="50" cx="50%" cy="0%" transform="translate(50%)" fill="#5e8f1e">
            </svg:circle>
            <svg:text x="50%" text-anchor="middle" y="25" fill="white">{{progressWidth}}</svg:text>
        </svg:g>
    </svg>
</div>